<template>
  <BContent
    class="content"
  >
    <template #navbar>
      <div>
        <span class="page-title fs-400 fw-bold mr-400">{{ $t("todoSync.title") }}</span>
        <br>
        <span class="notice">
          {{ $t("salesforceSettings.syncObjectType.todoMappingDesc") }}
        </span>
      </div>
    </template>
    <div class="tbody">
      <div
        v-for="(use, todoSync) in todoSyncSettingMap"
        :key="todoSync"
      >
        <div class="row">
          <BCheckbox
            v-model="todoSyncSettingMap[todoSync]"
            color="accent"
          />
          {{ $t(`todoSync.mapping.${todoSync}`) }}
        </div>
      </div>
      <BBtn
        type="primary"
        @click="saveSettings"
      >
        <span>{{ $t('general.save.text') }}</span>
      </BBtn>
    </div>
  </BContent>
</template>

<script lang="ts" setup>
import { onMounted, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { SfTodoSyncSettingsService } from '@/api/user/resources/salesforce/sf_todo_sync_settings';
import { useToast } from '@/composable/toast';
const { successToast } = useToast();
const i18n = useI18n();

const todoSyncSettingMap = ref({
  'bulk_mail': true,
  'call_result': true,
  'direct_mail': true,
  'receive_mail': true,
  'free_action': true,
});

const sfApi = new SfTodoSyncSettingsService();
const saveSettings = async (todoType, active) => {
  const todoTypeList = Object.entries(todoSyncSettingMap.value).map(([todoType, active]) => ({
    todoType,
    active,
  }));
  
  await sfApi.upsertSfTodoSyncSetting({
    sfTodoSyncSettingBody: {
      todoTypeList,
    },
  });
  successToast(i18n.t('general.success.to', { action: i18n.t('general.update.text') }));

  await load();
};
const load = async () => {
  const results = await sfApi.getSfTodoSyncSettings();
  if (results.data == null) {
    return;
  }
  for (const data of results.data) {
    for (const key in todoSyncSettingMap.value) {
      const todoSyncSetting = data;
      if (key === todoSyncSetting.todoType) {
        todoSyncSettingMap.value[key] = todoSyncSetting.active;
      }
    }
  }
};
onMounted(async () => {
  await load();
});
</script>

<style lang="scss" scoped>
.notice {
  color: $textcolor-light;
  white-space: pre-wrap;
}
.tbody {
  margin: 32px;
  width: 500px;
}
.row {
  display: flex;
  margin: 24px 0;
}
</style>
